import { useEffect, memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMutualFund, getMutualFundSideMenu, getNfo, getThemes } from "../../../redux/actions/mutualFund";
import { Filters, Themes, TrendingCard, TrendingList, NfoCard, NfoList, ExploreAllFunds } from "../../../containers";
import { Row, Col, Container } from 'react-bootstrap';
import { BzButton } from '../../../components';

const ExploreFunds = ({ showDetailPage, setShowDetailPage, setShowOverview, showOverview, showPlaceOrderModal, setIsShowPlaceOrderModal, setFundToBuy, showAllfundsModal, setIsshowAllfundsModal,
    setShowDetailPageNfo, showDetailPageNfo, handleOnShowFundOverView }) => {

    const [toggle, setToggle] = useState(null);
    const [filterToggle, setFilterToggle] = useState(true);
    const [checkedItems, setCheckedItems] = useState([]);
    const [nfoDetails, setNfoDetails] = useState();



    const handleCheckBox = (event) => {
        const { checked, value } = event.target;
        if (checked) {
            setCheckedItems([...checkedItems, value]);
        } else {
            setCheckedItems(checkedItems.filter(element => element !== value));
        }
    };


    useEffect(() => {
        // console.log(checkedItems)

    }, [checkedItems]);

    const hanldeOnFilter = () => {
        setFilterToggle(curr => !curr);
    };


    const { filters, themes, nfo, mutualFund } = useSelector(state => state.mutualFund);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getMutualFund());
        dispatch(getMutualFundSideMenu());
        dispatch(getNfo());
        dispatch(getThemes());
    }, [dispatch]);

    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col className='d-flex'>
                        {
                            filterToggle &&
                            <Col md={3} className='pe-5'>
                                <Filters MutualfundFilter={filters} checkedItems=
                                    {checkedItems} toggle={toggle} setToggle={setToggle} handleCheckBox={handleCheckBox} hanldeOnFilter={hanldeOnFilter} />
                            </Col>
                        }
                        <Col className='mf-right-section'>
                            {!showAllfundsModal ?
                                <Col>
                                    <div className='d-flex justify-content-end my-4'>
                                        {!showDetailPage && !showDetailPageNfo ? <BzButton className={`btn btn-md btn-primary btn-rounded`} onClick={() => { setIsshowAllfundsModal(true); }} >Explore All Funds</BzButton> : null}
                                    </div>

                                    {showDetailPage ?
                                        <>
                                            <TrendingList filterToggle={filterToggle} hanldeOnFilter={hanldeOnFilter} mutualFund={mutualFund} showPlaceOrderModal={showPlaceOrderModal} setIsShowPlaceOrderModal={setIsShowPlaceOrderModal} setFundToBuy={setFundToBuy} />
                                        </>
                                        :
                                        showDetailPageNfo ?
                                            <>
                                                <NfoList filterToggle={filterToggle} hanldeOnFilter={hanldeOnFilter} mutualFund={mutualFund} showPlaceOrderModal={showPlaceOrderModal} setIsShowPlaceOrderModal={setIsShowPlaceOrderModal} setFundToBuy={setFundToBuy} />
                                            </>
                                            :
                                            <>
                                                <div className='mf-explore-funds-scroll'>
                                                    <TrendingCard exploreFundsData={mutualFund} setShowDetailPage={setShowDetailPage} />
                                                    <NfoCard exploreFundsNfo={nfo} showDetailPageNfo={showDetailPageNfo} setShowDetailPageNfo={setShowDetailPageNfo} nfoDetails={nfoDetails} setNfoDetails={setNfoDetails} />
                                                    <Themes exploreFundsThemes={themes} />
                                                </div>
                                            </>
                                    }
                                </Col>
                                :
                                <Col>
                                    <ExploreAllFunds filterToggle={filterToggle} hanldeOnFilter={hanldeOnFilter} mutualFund={mutualFund} nfo={nfo}
                                        setFundToBuy={setFundToBuy} showAllfundsModal={showAllfundsModal}
                                        setIsshowAllfundsModal={setIsshowAllfundsModal}
                                        setIsShowPlaceOrderModal={setIsShowPlaceOrderModal}
                                        setShowOverview={setShowOverview} showOverview={showOverview} handleOnShowFundOverView={handleOnShowFundOverView} />
                                </Col>
                            }
                        </Col>

                    </Col>
                </Row>
            </Container>
        </>
    );

};
export default memo(ExploreFunds);
